import * as React from 'react';
import { SVGProps } from 'react';

const IconShareSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M11 2a2 2 0 0 1-3.392 1.436L4.888 5.34a1.997 1.997 0 0 1 .003 1.313l2.722 1.906a2 2 0 1 1-.525.853l-2.75-1.926a2 2 0 1 1-.006-2.978l2.754-1.927A2 2 0 1 1 11 2Z" />
  </svg>
);
export default IconShareSizeXs;
